import { __extends } from "tslib";
import { TaskBase } from '../TaskBase';
var VERTEX_DEF = "\nprecision highp float;\nuniform vec4 uTexMatrix[2];\n\n/* AGAL legacy atrib resolver require this names */\nattribute vec4 va0; // position\n\nvarying vec2 vUv;\nvoid main() {\n\tvec4 pos = va0;\n\n\tpos.xy = pos.xy * uTexMatrix[0].zw + uTexMatrix[0].xy;\n\tpos.z = pos.z * 2.0 - pos.w;\n\n    gl_Position = pos;\n\n\tvUv = clamp((va0.xy * uTexMatrix[1].zw) + uTexMatrix[1].xy, 0., 1.);\n}\n\n";
var FRAG_DEF = "\nprecision highp float;\nuniform sampler2D uSampler0;\nvarying vec2 vUv;\n\nvoid main() {\n    vec4 color = texture2D(uSampler0, vUv);\n    gl_FragColor = color;\n}\n\n";
var TaskBaseWebGL = /** @class */ (function (_super) {
    __extends(TaskBaseWebGL, _super);
    function TaskBaseWebGL() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TaskBaseWebGL.prototype, "name", {
        get: function () {
            return this.constructor.name;
        },
        enumerable: false,
        configurable: true
    });
    TaskBaseWebGL.prototype.updateProgram = function (stage) {
        if (this._program3D)
            this._program3D.dispose();
        this._program3D = stage.context.createProgram();
        this._program3D.name = this.name;
        this._program3D.uploadRaw(this.getVertexCode(), this.getFragmentCode());
        this._program3DInvalid = false;
    };
    TaskBaseWebGL.prototype.activate = function (_stage, _projection, _depthTexture) {
        this.computeVertexData();
        this._program3D.uploadUniform('uTexMatrix', this._vertexConstantData);
    };
    TaskBaseWebGL.prototype.getVertexCode = function () {
        return VERTEX_DEF;
    };
    TaskBaseWebGL.prototype.getFragmentCode = function () {
        return FRAG_DEF;
    };
    return TaskBaseWebGL;
}(TaskBase));
export { TaskBaseWebGL };
